import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ECollection } from '../enums/ECollection';
import { EModelApiPaths } from '../enums/EModelApiPaths';
import { AuthService } from './auth.service';
import { BaseService } from './base-service';
import { UserService } from './user.service';
import { UtilsService } from './utils.service';

@Injectable({ providedIn: 'root' })
export class PaymentMethodService extends BaseService {
    constructor(public override http: HttpClient,
                public override utilsService: UtilsService,
                public override userService: UserService,
                public authService: AuthService) {
        super(http, userService, utilsService, `/schema/${environment.USER_PATH}/${environment.INS}/${environment.DB}/${ECollection.SW_RAZORPAY_TRANSACTIONS}`);
    }

    async razorpayCreateOrder<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.RAZORPAY_CREATE_ORDER, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async razorpayCheckOrderStatus<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.RAZORPAY_ORDER_STATUS, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async paypalCreateOrder<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.PAYPAL_CREATE_ORDER, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async paypalCaptureOrder<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.PAYPAL_CAPTURE_ORDER, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }


    async paytmCreateOrder<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.PAYTM_CREATE_ORDER, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async paytmCheckOrderStatus<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.PAYTM_ORDER_STATUS, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async orderCashOnDelivery<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.ORDER_CASH_ON_DELIVERY, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }
}
